export const ROOT = "/admin/survey";
export const SURVEY_DETAIL = `${ROOT}/view/:surveyUuid`;